import React from "react";
import notfound from "../../assets/images/404.svg";
import styles from "../../styles/settings/notfound.module.css";
import { Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";

const NotFound = () => {
  return (
    <>
      <div className={styles.main_container}>
        <div className={styles.image_container}>
          <img src={notfound} alt="not found" className={styles.image} />
        </div>
        <div className={styles.text_container}>
          <p className={styles.heading}>Oops!</p>
          <p className={styles.subheading}>Page not found</p>
          <Button
            variant="contained"
            endIcon={<EastIcon />}
            className={styles.button}
            onClick={() => {
              window.location.href = "/dashboard";
            }}
          >
            Go to Home
          </Button>
        </div>
      </div>
    </>
  );
};

export default NotFound;
